module.exports = __webpack_public_path__ + "static/img/3.3d074f43.png";